import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';
import { type FC, useMemo } from 'react';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetCountryList } from '../../hooks/use-get-country-list';
import type { CountryInfo } from '../../types';

interface CountrySelectorProps
  extends Pick<FormItemProps, 'rules' | 'name'>,
    Pick<SelectProps, 'value' | 'mode' | 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  onChange?: (value?: CountryInfo) => void;
  className?: string;
  tabIndex?: number;
  disableValidation?: boolean;
  selectedCountry?: string[] | string;
  isRemoved?: boolean;
  labelWithValue?: boolean;
  dataTestId?: string;
}

export const CountrySelect: FC<CountrySelectorProps> = ({
  placeholder = i18n.t('translation:default.fields.country.placeholder'),
  label = i18n.t('translation:default.fields.country.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange = () => {},
  value = '',
  className = '',
  tabIndex,
  mode,
  disableValidation = false,
  selectedCountry = [],
  isRemoved = false,
  labelWithValue = false,
  dataTestId,
}) => {
  const { data: countryList = [], isLoading } = useGetCountryList();

  const allOptions = useMemo(
    () =>
      countryList.map((country) => ({
        label: country.countryName,
        value: country.countryCode,
      })),
    [countryList],
  );

  const options = useMemo(() => {
    if (allOptions && selectedCountry.length > 0 && allOptions.length > 0) {
      return allOptions.filter((country) => selectedCountry.includes(country.value));
    }
    return allOptions;
  }, [selectedCountry, allOptions]);

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      // @ts-ignore TODO: refactor CountrySelect to use Select instead of FormSelectBox
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      isRemoved={isRemoved}
      labelWithValue={labelWithValue}
      data-testid={dataTestId}
    />
  );
};
